module.exports = __webpack_public_path__ + "static/media/bg_kost.b28b3fa2.png";